import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button } from 'reactstrap'
import { BiPlus } from 'react-icons/bi'
import { getTasksV2 } from 'features/dashboard/Task.actionTypes'
import { getTeamVehiclesLight } from 'features/dashboard/Vehicle.actionTypes'
import MiniNavbar from './MapEditorNavbar'
import HeatMapsModal from './HeatMapsModal'
import { getMapAreas } from 'features/dashboard/Map.actionTypes'

const HeatMaps = ({ match }) => {
    const { slug } = match.params
    const dispatch = useDispatch()
    const [image, setImage] = useState(null)
    const [modal, setModal] = useState(false)
    const toggle = () => setModal(!modal)

    useEffect(() => {
        dispatch(getTasksV2(slug))
        dispatch(getMapAreas(slug))
        dispatch(getTeamVehiclesLight({ slug }))
    }, [dispatch, slug])

    return (
        <>
            <div style={{ marginTop: '-45px' }}>
                <h3>Maps</h3>
            </div>
            <div className="big-org-container" style={{ padding: '0 24px 0 0', gap: '0' }}>
                <div style={{ marginTop: '24px' }}>
                    <MiniNavbar slug={slug} isActive="heat-map" />
                </div>
                <div
                    className="heading-container-org"
                    style={{ marginTop: '38px', alignItems: 'center' }}
                >
                    <div>
                        <div className="mb-2 d-flex align-items-center">
                            <span className="header-text-org">Heat map</span>
                        </div>
                        <span className="small-text-org">
                            Generate and export heat maps of your fleet.
                        </span>
                    </div>
                    <div>
                        <Button
                            className="modals-new-btns save-btn-modal"
                            style={{
                                height: '40px',
                                fontWeight: '500',
                                fontSize: '14px',
                                lineHeight: '28px',
                            }}
                            onClick={toggle}
                        >
                            <BiPlus size={18} />
                            Create heat map
                        </Button>
                    </div>
                </div>
                <hr />
                {image && <img src={`data:image/svg+xml;base64,${btoa(image)}`} alt="heat" />}
            </div>
            <HeatMapsModal modal={modal} toggle={toggle} setImage={setImage} />
        </>
    )
}
export default HeatMaps
